import { z } from "zod"

/**
 * Validation schema for organization profile form
 * Matches UpdateOrganizationProfileDto from @mimber/schema
 */
export const organizationProfileSchema = z.object({
  aboutText: z.string().max(5000).nullable(),
  industry: z.string().max(255).nullable(),
  foundedDate: z.string().nullable(),
  taxId: z.string().max(50).nullable(),
  primaryColor: z
    .string()
    .regex(/^#[0-9A-F]{6}$/i)
    .nullable(),
  secondaryColor: z
    .string()
    .regex(/^#[0-9A-F]{6}$/i)
    .nullable(),
  accentColor: z
    .string()
    .regex(/^#[0-9A-F]{6}$/i)
    .nullable(),
  socialMediaFacebook: z.string().url().max(255).nullable().or(z.literal("")),
  socialMediaTwitter: z.string().url().max(255).nullable().or(z.literal("")),
  socialMediaLinkedin: z.string().url().max(255).nullable().or(z.literal("")),
  socialMediaInstagram: z.string().url().max(255).nullable().or(z.literal("")),
  isPublic: z.boolean(),
  publicDescription: z.string().max(500).nullable(),
  publicContactEmail: z.string().email().max(255).nullable().or(z.literal("")),
})

export type OrganizationProfileFormData = z.infer<
  typeof organizationProfileSchema
>
